(function () {
  'use strict';
  function init(root) {
    var cfgEl = root.querySelector('[data-abq-cfg]');
    if (!cfgEl) return;
    var C = JSON.parse(cfgEl.textContent), U = C.ui, R = C.result, P = C.product;
    var card = root.querySelector('.abq-card'), footer = root.querySelector('.abq-footer'),
      btn = root.querySelector('.abq-continue'), pbar = root.querySelector('.abq-pbar');
    var steps = C.steps.concat([{ type: 'loader' }, { type: 'result' }]);
    var answers = {}, i = 0;

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function rich(s) { return esc(s).replace(/\*\*(.+?)\*\*/g, '<span class="hi">$1</span>'); }
    function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

    var HEAD = '<circle cx="16" cy="17" r="9" fill="#fff" stroke="#0A1628" stroke-width="1.5"/>';
    var ICONS = {
      hairline: HEAD + '<path d="M7.6 15c1-4.4 4-6.4 8.4-6.4s7.4 2 8.4 6.4c-2-2.7-5-3.9-8.4-3.9S9.6 12.3 7.6 15Z" fill="#0A1628"/><path d="M9 14.4C10.5 12 13 11 16 11s5.5 1 7 3.4" stroke="#00AAFF" stroke-width="1.7" fill="none" stroke-linecap="round"/>',
      crown: HEAD + '<path d="M7.6 16c0-5 3.5-8 8.4-8s8.4 3 8.4 8c-2-3-5-4.2-8.4-4.2S9.6 13 7.6 16Z" fill="#0A1628"/><circle cx="16" cy="12.3" r="2.6" fill="#fff" stroke="#00AAFF" stroke-width="1.5"/>',
      both: HEAD + '<path d="M8 15.4c1-4 4-6 8-6s7 2 8 6c-2-2.6-4.8-3.7-8-3.7S10 12.8 8 15.4Z" fill="#0A1628"/><path d="M9.6 14.4C11 12.4 13.2 11.5 16 11.5s5 .9 6.4 2.9" stroke="#00AAFF" stroke-width="1.6" fill="none" stroke-linecap="round"/><circle cx="16" cy="12.6" r="2.1" fill="#fff" stroke="#00AAFF" stroke-width="1.4"/>',
      patchy: HEAD + '<path d="M7.6 16c0-5 3.5-8 8.4-8s8.4 3 8.4 8c-2-3-5-4.2-8.4-4.2S9.6 13 7.6 16Z" fill="#0A1628"/><circle cx="12.3" cy="12.6" r="1.6" fill="#fff" stroke="#00AAFF" stroke-width="1"/><circle cx="18.7" cy="11.9" r="1.5" fill="#fff" stroke="#00AAFF" stroke-width="1"/><circle cx="16" cy="14.4" r="1.3" fill="#fff" stroke="#00AAFF" stroke-width="1"/>',
      prevent: HEAD + '<path d="M7 17c0-6 4-9.4 9-9.4s9 3.4 9 9.4c-2.2-3.5-5.2-5.1-9-5.1S9.2 13.5 7 17Z" fill="#0A1628"/><path d="M16 13.4l3 1.1v1.6c0 1.6-1.2 2.7-3 3.4-1.8-.7-3-1.8-3-3.4v-1.6l3-1.1Z" fill="#00AAFF"/><path d="M14.8 16.3l.9.9 1.7-1.7" stroke="#fff" stroke-width="1.1" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'
    };
    function icon(k) {
      if (!k) return '';
      if (k.indexOf('svg:') === 0) return '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">' + (ICONS[k.slice(4)] || '') + '</svg>';
      return esc(k);
    }

    function qSteps() { return steps.filter(function (s) { return s.type === 'question'; }); }
    function render() {
      var s = steps[i];
      pbar.style.width = Math.min(100, Math.round(i / (steps.length - 2) * 100)) + '%';
      footer.hidden = true; card.innerHTML = '';
      root.scrollIntoView({ block: 'start' }); window.scrollTo(0, 0);
      if (s.type === 'interstitial') return renderInter(s);
      if (s.type === 'loader') return renderLoader();
      if (s.type === 'result') return renderResult();
      renderQuestion(s);
    }
    function showBtn(label, disabled, fn) { footer.hidden = false; btn.textContent = label; btn.disabled = !!disabled; btn.onclick = fn; }
    function next() { i++; render(); }

    function renderQuestion(s) {
      var back = el('button', 'abq-back', esc(U.back)); back.type = 'button';
      if (i > 0) { back.style.display = 'inline-block'; back.onclick = function () { i--; render(); }; }
      card.appendChild(back);
      var idx = qSteps().indexOf(s) + 1;
      card.appendChild(el('div', 'abq-eyebrow abq-qcount', esc(U.counter.replace('{n}', idx).replace('{t}', qSteps().length))));
      card.appendChild(el('h2', 'abq-qtitle', esc(s.title)));
      if (s.sub) card.appendChild(el('div', 'abq-qsub', esc(s.sub)));
      var multi = s.multi, wrap;
      if (s.layout === 'image') {
        wrap = el('div', 'abq-imgopts' + ((s.images || []).some(Boolean) ? '' : ' noimg'));
        s.opts.forEach(function (o, k) {
          var b = el('button', 'abq-opt abq-imgcard'); b.type = 'button';
          if (answers[s.key] === k) b.classList.add('sel');
          var src = s.images && s.images[k];
          b.innerHTML = src ? '<img src="' + esc(src) + '" alt="' + esc(o.label) + '" loading="lazy"><span class="abq-cap">' + esc(o.label) + '</span>' : '<span class="abq-ph"><span>' + esc(o.label) + '</span></span>';
          b.onclick = function () { answers[s.key] = k; setTimeout(next, 160); };
          wrap.appendChild(b);
        });
      } else {
        wrap = el('div', 'abq-opts');
        s.opts.forEach(function (o, k) {
          var b = el('button', 'abq-opt'); b.type = 'button';
          var cur = answers[s.key];
          if (multi ? (cur || []).indexOf(k) >= 0 : cur === k) b.classList.add('sel');
          b.innerHTML = '<span class="abq-ico">' + icon(o.ico) + '</span><span class="abq-lbl">' + esc(o.label) + '</span><span class="abq-tick"></span>';
          b.onclick = function () {
            if (multi) {
              var arr = answers[s.key] || [], ex = s.exclusive ? s.opts.length - 1 : -1;
              if (k === ex) arr = arr.indexOf(k) >= 0 ? [] : [k];
              else { arr = arr.filter(function (x) { return x !== ex; }); arr = arr.indexOf(k) >= 0 ? arr.filter(function (x) { return x !== k; }) : arr.concat(k); }
              answers[s.key] = arr; sync();
            } else { answers[s.key] = k; setTimeout(next, 170); }
          };
          wrap.appendChild(b);
        });
      }
      card.appendChild(wrap);
      function sync() {
        var arr = answers[s.key] || [];
        [].forEach.call(wrap.children, function (b, k) { b.classList.toggle('sel', arr.indexOf(k) >= 0); });
        btn.disabled = !arr.length;
      }
      if (multi) card.appendChild(el('div', 'abq-multinote', esc(U.multi_note)));
      if (s.why) card.appendChild(el('div', 'abq-why', '<b>' + esc(U.why_label) + '</b><span>' + esc(s.why) + '</span>'));
      if (multi) showBtn(U.next, !(answers[s.key] || []).length, next);
    }

    function renderInter(s) {
      card.appendChild(el('div', 'abq-inter', '<div class="abq-big"><em>' + esc(s.big) + '</em> ' + esc(s.tail) + '</div><p>' + esc(s.copy) + '</p>'));
      showBtn(U.next, false, next);
    }

    function renderLoader() {
      var L = C.loader, w = el('div', 'abq-loader');
      w.innerHTML = '<h2>' + esc(L.title) + '</h2><div class="abq-ltrack"><div class="abq-lfill"></div></div><div>' +
        L.steps.map(function (t) { return '<div class="abq-lstep"><span>' + esc(t) + '</span><span class="abq-c">0 %</span></div>'; }).join('') + '</div>';
      card.appendChild(w);
      var fill = w.querySelector('.abq-lfill'), rows = w.querySelectorAll('.abq-lstep'), p = 0, per = 100 / L.steps.length;
      var t = setInterval(function () {
        p += 2; fill.style.width = Math.min(100, p) + '%';
        var done = Math.floor(p / per);
        [].forEach.call(rows, function (r, k) {
          var c = r.querySelector('.abq-c');
          if (k < done) { r.classList.add('done'); c.textContent = '100 %'; }
          else if (k === done) { r.classList.add('done'); c.textContent = Math.min(100, Math.round(((p % per) / per) * 100)) + ' %'; }
        });
        if (p >= 100) { clearInterval(t); setTimeout(next, 450); }
      }, 55);
    }

    function profile() {
      var A = answers, sev = (A.severity != null ? A.severity : 0) + 1, dur = (A.duration != null ? A.duration : 0) + 1;
      var score = sev + dur;
      if (A.area === 2 || A.area === 3) score += 1;
      if (A.family === 0) score += 1;
      if (A.stress === 2) score += 1; else if (A.stress === 3) score += 2;
      var tier = Math.max(score, 5) + 1 >= 8 ? 'advanced' : 'elevated';
      var tried = A.tried || [];
      return {
        tier: tier,
        triedTopicals: tried.some(function (x) { return x === 0 || x === 1 || x === 3; }),
        inherited: A.family === 0,
        impactHigh: A.severity >= 2 || tier === 'advanced',
        pack: String(tier === 'advanced' ? R.rec_advanced : R.rec_elevated)
      };
    }
    function projDate() { var d = new Date(); d.setDate(d.getDate() + 90); return d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }); }

    function renderResult() {
      var Pf = profile(), v = P['m' + Pf.pack] || P.m3 || {};
      var stage = Pf.tier === 'advanced' ? R.stage_advanced : R.stage_elevated;
      var trigger = Pf.inherited ? R.trigger_inherited : R.trigger_default;
      var dHead = Pf.triedTopicals ? R.diag_tried_title : R.diag_new_title;
      var dBody = (Pf.triedTopicals ? R.diag_tried_body : R.diag_new_body).replace('{trigger}', trigger).replace('{stage}', stage.toLowerCase());
      var rows = R.rows.map(function (r) { return '<div class="abq-row"><span class="abq-k">' + esc(r[0]) + '</span><span class="abq-v">' + esc(r[1]) + '</span></div>'; }).join('');
      if (v.price) rows += '<div class="abq-row"><span class="abq-k">' + esc(R.price_label) + '</span><span class="abq-v">' + v.price + '</span></div>';
      var w = el('div', 'abq-result');
      w.innerHTML = '<div class="abq-eyebrow">' + esc(R.eyebrow) + '</div><h2>' + esc(R.title) + '</h2><div class="abq-lede">' + esc(R.lede) + '</div>' +
        '<div class="abq-profile">' +
        '<div class="abq-pcell"><div class="k">' + esc(R.lbl_stage) + '</div><div class="v' + (Pf.tier === 'advanced' ? ' flag' : '') + '">' + esc(stage) + '</div></div>' +
        '<div class="abq-pcell"><div class="k">' + esc(R.lbl_trigger) + '</div><div class="v">' + esc(trigger) + '</div></div>' +
        '<div class="abq-pcell"><div class="k">' + esc(R.lbl_impact) + '</div><div class="v' + (Pf.impactHigh ? ' flag' : '') + '">' + esc(Pf.impactHigh ? R.impact_high : R.impact_moderate) + '</div></div>' +
        '<div class="abq-pcell"><div class="k">' + esc(R.lbl_approach) + '</div><div class="v">' + esc(R.val_approach) + '</div></div></div>' +
        '<div class="abq-diag"><div class="abq-eyebrow">' + esc(R.diag_eyebrow) + '</div><h3>' + esc(dHead) + '</h3><p>' + rich(dBody) + '</p></div>' +
        '<div class="abq-rec"><div class="abq-tag">' + esc(R.tag) + '</div><h3>' + esc(R['rec_title_' + Pf.pack] || R.rec_title_3) + '</h3><div class="abq-sub">' + esc(R['rec_sub_' + Pf.pack] || R.rec_sub_3) + '</div>' + rows + '</div>' +
        (R.discount_note && R.discount_code ? '<div class="abq-disc">' + esc(R.discount_note) + '</div>' : '') +
        '<div class="abq-timeline">' + rich(R.timeline.replace('{date}', projDate())) + '</div>' +
        '<div class="abq-error" hidden></div>' +
        (P.url ? '<a class="abq-secondary" href="' + esc(P.url + (v.id ? '?variant=' + v.id + '&src=quiz' : '?src=quiz')) + '">' + esc(R.secondary_label) + '</a>' : '') +
        '<div class="abq-fine">' + esc(R.disclaimer) + '</div>';
      card.appendChild(w);
      var err = w.querySelector('.abq-error');
      showBtn(R.cta_label, !v.id, function () {
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true'); btn.textContent = R.cta_loading; err.hidden = true;
        fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: { _quiz: 'oui' } }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (o) {
          if (!o.ok || o.j.status) throw new Error(o.j.description || o.j.message || 'Erreur');
          var cart = (window.routes && window.routes.cart_url) || '/cart';
          window.location.href = R.discount_code ? '/discount/' + encodeURIComponent(R.discount_code) + '?redirect=' + encodeURIComponent(cart) : cart;
        }).catch(function (e) {
          btn.removeAttribute('aria-busy'); btn.textContent = R.cta_label; err.textContent = e.message; err.hidden = false;
        });
      });
    }
    render();
  }
  document.querySelectorAll('.ab-quiz').forEach(init);
})();
